import {IElementContainer} from "./ElementContainer";
import {SimpleSignal} from "../SimpleSignal";
import {Templating} from "../Templating";

export class ClosingContainer implements IElementContainer
{
	public element: HTMLElement;
	public labelElement: HTMLElement;
	public openSignal: SimpleSignal;

	constructor(config: any)
	{
		this.element = Templating.renderDOMFromScript(config.scriptId, {label: config.label});

		this.labelElement = this.element.querySelector("[data-label]");
		this.labelElement.addEventListener("click", this.onLabelClick);

		this.openSignal = new SimpleSignal();
		this.close();
	}

	public disable()
	{
		this.labelElement.removeEventListener("click", this.onLabelClick);
	}

	public open()
	{
		this.element.classList.remove("closed");
	}

	public close()
	{
		this.element.classList.add("closed");
	}

	private onLabelClick = (event: MouseEvent) =>
	{
		var opening = this.element.classList.contains("closed");
		if (opening)
		{
			this.open();
		}
		else
		{
			this.close();
		}

		this.openSignal.dispatch(opening, this);
		//this.element.classList.toggle("closed");
	};
}